export default __webpack_public_path__ + "static/media/goback.290b8c8d.svg";